/* eslint-disable */
import { TextStyle } from './common.js';

export interface CodeBlockData {
  /** Styling for the code block's text. */
  textStyle?: TextStyle;
}

const baseCodeBlockData: object = {};

export const CodeBlockData = {
  fromJSON(object: any): CodeBlockData {
    const message = { ...baseCodeBlockData } as CodeBlockData;
    message.textStyle =
      object.textStyle !== undefined && object.textStyle !== null
        ? TextStyle.fromJSON(object.textStyle)
        : undefined;
    return message;
  },

  toJSON(message: CodeBlockData): unknown {
    const obj: any = {};
    message.textStyle !== undefined &&
      (obj.textStyle = message.textStyle ? TextStyle.toJSON(message.textStyle) : undefined);
    return obj;
  },
};
